import { http_client } from "@/plugins/http_client";

const cargarInstituciones = async (body) =>
  await http_client(`/api/importar/instituciones`, body, 'post', { headers: { "content-type": "multipart/form-data" }})

const descargarTipoInstitucion = async () =>
  await http_client(`/api/catalogo-tipo-institucion`, {}, 'get', {"content-type": "blob",}, true, "arraybuffer");

const descargarPlantilla = async () =>
  await http_client(`/api/plantilla-tipo-institucion`, {}, 'get', {"content-type": "blob",}, true, "arraybuffer");

const descargarBanco = async () =>
  await http_client(`/api/catalogo-acreedores`, {}, 'get', {"content-type": "blob",}, true, "arraybuffer");

const descargarHorario = async () =>
  await http_client(`/api/horarios-administrativos`, {}, 'get', {"content-type": "blob",}, true, "arraybuffer");

const añadirInstitucion = async (body) =>
    await http_client(`/api/institucion/crear`, body, 'post')

export default {
  cargarInstituciones,
  descargarTipoInstitucion,
  descargarPlantilla,
  descargarBanco,
  descargarHorario,
  añadirInstitucion,
};
